<template>
  <div class="media-template" theme>
    <div id="media-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'media',
      parts: [
        {
          elem: '#media-content',
          htmlFile: 'teacher-list'
        }
      ],
      hashPart: '#media-content'
    }
  }
}
</script>
